import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import SendIcon from "@mui/icons-material/Send";
import DownloadIcon from "@mui/icons-material/Download";
import html2pdf from "html2pdf.js";

const SalarySlip = () => {
  const slipRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [email, setEmail] = useState("");

  const earnings = [
    { id: 1, name: "Basic Salary", amount: "$8000.00" },
    { id: 2, name: "House Rent Allowance (H.R.A.)", amount: "$50.00" },
    { id: 3, name: "Conveyance", amount: "$50.00" },
    { id: 4, name: "Other Allowance", amount: "$50.00" },
  ];

  const deductions = [
    { id: 1, name: "Tax Deducted at Source (T.D.S.)", amount: "$15.00" },
    { id: 2, name: "Provident Fund", amount: "$200.00" },
    { id: 3, name: "ESI", amount: "$0.00" },
    { id: 4, name: "Other Deductions", amount: "$0.00" },
  ];
  // Print Function
  const handlePrint = () => {
    const printContents = document.querySelector(".Main").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  // Download PDF
  const handleDownload = () => {
    html2pdf().from(slipRef.current).save("SalarySlip.pdf");
  };

  // Open Email Dialog
  const handleSendInvoice = () => {
    setOpenDialog(true);
  };

  // Send Invoice via Email
  const sendInvoiceByEmail = () => {
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }
    const subject = encodeURIComponent("Your Salary Slip");
    const body = encodeURIComponent("Please find the attached salary slip.");
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
    setOpenDialog(false);
  };
  return (
    <Box p={4} className="Main">
      <Typography variant="h5" textAlign="left" fontWeight="bold" gutterBottom>
        Salary Slip
      </Typography>
      <Paper elevation={3} sx={{ p: 8 }} ref={slipRef}>
        <Typography fontWeight="bold" textAlign="left">
          <span style={{ color: "gray", fontWeight: "bold" }}>Salary Slip</span>{" "}
          01/Nov/2020
        </Typography>
        <Divider sx={{ color: "gray" }} />

        {/* Employee & Company Info */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={6} display="flex" flexDirection="column" alignItems="flex-start">
            <Typography fontWeight="bold">From:</Typography>
            <Typography>PixelWibes</Typography>
            <Typography>111 Berkeley Rd</Typography>
            <Typography>STREET ON THE FOSSE, Poland</Typography>
            <Typography>Email: info@deoweb.com</Typography>
            <Typography>Phone: +44 888 666 3333</Typography>
          </Grid>

          <Grid item xs={6} display="flex" flexDirection="column" alignItems="flex-start">
            <Typography fontWeight="bold">To:</Typography>
            <Typography>Dylan Hunter</Typography>
            <Typography>Web Designer</Typography>
            <Typography>Employee ID: 00008</Typography>
            <Typography>Joining Date: 10 Feb 2017</Typography>
            <Typography>Phone: +66 243 456 789</Typography>
          </Grid>
        </Grid>

        {/* Earnings & Deductions */}
        <Grid container spacing={2} mt={3}>
          <Grid item xs={6}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>EARNINGS</TableCell>
                    <TableCell>AMOUNT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {earnings.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={6}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>DEDUCTIONS</TableCell>
                    <TableCell>AMOUNT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deductions.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* Total Calculation */}
        <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box mt={2} textAlign="left" sx={{ flexGrow: 1 }}>
            <Typography fontWeight="bold">(ER) - (DE) : $7935.00</Typography>
            <Typography variant="h6" fontWeight="bold">Total: $7935.00</Typography>
          </Box>
          <Box mt={2} sx={{ display: "flex", gap: 2 }}>
            <Button variant="outlined" startIcon={<PrintIcon />} onClick={handlePrint}>
              Print
            </Button>
          
            <Button variant="contained" color="primary" startIcon={<SendIcon />} onClick={handleSendInvoice}>
              Send Invoice
            </Button>
          </Box>
        </Grid>
      </Paper>

      {/* Email Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Send Invoice via Email</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Recipient Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={sendInvoiceByEmail} color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SalarySlip;
